$dependencyManager.addDependencyCallback('gsap', () => {
  class MadMap {
      constructor(container) {
          this.$container = jQuery(container);
          this.id = this.$container.data('map-id');
          this.embedCode = atob(this.$container.data('embed-code'));
          this.init();
      }

      init() {
          const embed = jQuery('<div>').html(this.embedCode).find('iframe');
          embed.addClass('mad-map__iframe');
          
          const confirmMap = () => {
              this.$container.find('.mad-map__overlay').hide();
              this.$container.find('.mad-map__wrapper').append(embed[0]);
              gsap.fromTo(this.$container.find('.mad-map__wrapper'), {
                  filter: "blur(3px)"
              }, {
                  filter: "blur(0px)",
                  duration: 3
              });
          }

          const confirmMapIfValid = () => {
              if (typeof CLI !== 'undefined' && CLI?.consent?.maps === true) {
                  confirmMap();
              }
          }

          this.$container.find('.mad-map__overlay-button').on('click', confirmMap);

          if (typeof CLI === 'undefined') {
              jQuery('.wt-cli-cookie-bar-container a').on('click', () => { setTimeout(confirmMapIfValid, 100); });
          } else if (CLI?.consent?.maps === true) {
              confirmMap();
          } else {
              jQuery('.wt-cli-cookie-bar-container a').on('click', () => { setTimeout(confirmMapIfValid, 100); });
          }
      }
  }

  jQuery(document).ready(function ($) {
      const mapContainers = document.querySelectorAll('.mad-map__container');
      mapContainers.forEach(container => {
          new MadMap(container);
      });
  });
});
